(function () {
  "use strict";

  AddYammerUsersCtrl.$inject = ['$scope', 'resolveData'];
  angular
    .module('trainerWebApp.controllers')
    .controller('AddYammerUsersCtrl', AddYammerUsersCtrl);

  function AddYammerUsersCtrl($scope, resolveData) {

    // small shim to populate resolvedData
    $scope.resolvedData = resolveData;
  }

})();
